import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import { router } from '@/plugins/router/system/about'
// import '@/plugins/vuex'
import '@/utils/axios'
import '@/utils/lodash'
import '@/assets/css/common.styl'
// import '@/assets/common/js/palau-jsbridge-4.1.1'
import { Toast, List, Loading, Overlay } from 'vant'
Vue.use(Toast)
Vue.use(List)
Vue.use(Loading)
Vue.use(Overlay)
Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
